export default "__VITE_ASSET__c5a5d406__"